import * as types from '../../../actions';

const initialState = {
  items: [],
  status:0,
  totalPage:0,
  numRows:0,
  item:{
      id:'',
      name:'',
      certificateDetails:'',
      certificateRequired:false
  },
  activity:'',
  errorData:'',
  skillsMasterData: [] 
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 

    switch(action.type) {
        // ************** SKILL_LIST_AFFILIATE *********************
        case types.SKILL_LIST_AFFILIATE_SUCCESS:
            if(response.status===200){
                if(response.data.hasOwnProperty('results')){
                    let totalPage = Math.ceil(response.data.count/response.data.page_size);
                    return {
                        ...state,
                        items: response.data.results,
                        status: response.status,
                        activity: types.SKILL_LIST_AFFILIATE_SUCCESS+timeVar,
                        totalPage: totalPage,
                        numRows:response.data.results.length               
                    };
                }else{
                    return {
                        ...state,
                        items: response.data,
                        status: response.status,
                        activity: types.SKILL_LIST_AFFILIATE_SUCCESS,  
                        errorData: response.data,         
                    };
                }
              
            }else{
                return { ...state, status: response.status,    
                    activity: types.SKILL_LIST_AFFILIATE_ERROR+timeVar                             
                };
            } 
        case types.SKILL_LIST_AFFILIATE_ERROR: // return { ...state, response }; 
            return { ...state, status: response.status,    
                activity:types.SKILL_LIST_AFFILIATE_ERROR+timeVar, response                      
            };

        // ************** SKILL_LIST_AFFILIATE *************************
        case types.SKILL_ADD_AFFILIATE_SUCCESS:
            if(response.status===200 || response.status===201){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity: types.SKILL_ADD_AFFILIATE_SUCCESS+timeVar 
                }
            }
            else{
                return { ...state, status: response.status,    
                    activity: types.SKILL_ADD_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                            
                };
            }     
        case types.SKILL_ADD_AFFILIATE_ERROR:
            return {
                ...state,
                status: response.status,    
                activity: types.SKILL_ADD_AFFILIATE_ERROR+timeVar                             
            };

        // ************** SKILL_UPDATE_AFFILIATE_ *************************
        case types.SKILL_UPDATE_AFFILIATE_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity: types.SKILL_UPDATE_AFFILIATE_SUCCESS+timeVar          
                }       
            } else{
                return { ...state, status: response.status,    
                    activity: types.SKILL_UPDATE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                             
                };
            }  
        case types.SKILL_UPDATE_AFFILIATE_ERROR:
            return { ...state, status: response.status,    
                activity:types.SKILL_UPDATE_AFFILIATE_ERROR+timeVar                             
            };

        // ************** SKILL_DELETE_AFFILIATE *************************
        case types.SKILL_DELETE_AFFILIATE_SUCCESS:
            if(response.status===200){
                const id = response.data.id;                
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),             
                    status: response.status,
                    activity: types.SKILL_DELETE_AFFILIATE_SUCCESS+timeVar    
                }
            } else{
                return { ...state, status: response.status,    
                    activity: types.SKILL_DELETE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                             
                };
            }  
        case types.SKILL_DELETE_AFFILIATE_ERROR:
            return { ...state, response }; 

        case types.UPDATE_SKILL_INDEX_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.UPDATE_SKILL_INDEX_SUCCESS+timeVar,
                }     
            }else{
                return {
                    status:response.status,
                    activity:types.UPDATE_SKILL_INDEX_ERROR+timeVar,
                    errorData: response.data,
                }     
            }
        case types.UPDATE_SKILL_INDEX_ERROR: 
            return {
                status:response.status,
                activity:types.UPDATE_SKILL_INDEX_ERROR+timeVar,
                errorData: response.data,
            }    

        case types.SKILL_SUGGESTION_SUCCESS:
            if(response && response.status===200){
                return {
                    ...state,
                    status:response && response.status ? response.status : '',
                    activity:types.SKILL_SUGGESTION_SUCCESS+timeVar,
                    skillsMasterData: response && response.data ? response.data : '',
                }     
            }else{
                return {
                    status:response && response.status ? response.status : '',
                    activity:types.SKILL_SUGGESTION_ERROR+timeVar,
                    errorData: response && response.data ? response.data : '',
                }     
            }
        case types.SKILL_SUGGESTION_ERROR: 
            return {
                status:response && response.status ? response.status : '',
                activity:types.SKILL_SUGGESTION_ERROR+timeVar,
                errorData: response && response.data ? response.data : '',
            } 


        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name: '',
                    certificateDetails:'',
                    certificateRequired:false
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
  }
};